var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.2929L12.1464 8.14645C12.3417 7.95118 12.6583 7.95118 12.8536 8.14645C13.0488 8.34171 13.0488 8.65829 12.8536 8.85355L8.85355 12.8536C8.65829 13.0488 8.34171 13.0488 8.14645 12.8536L4.14645 8.85355C3.95118 8.65829 3.95118 8.34171 4.14645 8.14645C4.34171 7.95118 4.65829 7.95118 4.85355 8.14645L8 11.2929V0.5C8 0.223858 8.22386 0 8.5 0C8.77614 0 9 0.223858 9 0.5V11.2929ZM16 12.5C16 12.2239 16.2239 12 16.5 12C16.7761 12 17 12.2239 17 12.5V15.5C17 16.8807 15.8807 18 14.5 18H2.5C1.11929 18 0 16.8807 0 15.5V12.5C0 12.2239 0.223858 12 0.5 12C0.776142 12 1 12.2239 1 12.5L1 15.5C1 16.3284 1.67157 17 2.5 17H14.5C15.3284 17 16 16.3284 16 15.5V12.5Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadReport);
export default __webpack_public_path__ + "static/media/download-report.6a7b55093cfb6b64e00707715a60298c.svg";
export { ForwardRef as ReactComponent };